import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayExceptionsPage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayExceptionsPage";
import TASPositivePayExceptionCheckForm from "components/pages/TASPositivePayExceptionsPage/classes/TASPositivePayExceptionCheckForm";
import TASPositivePayExceptionCheckFormUI from "components/pages/TASPositivePayExceptionsPage/classes/TASPositivePayExceptionCheckFormUI";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayExceptionsActionSelected2
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Exceptions" capture group.
 */
export default function CapturePositivePayExceptionsActionSelected2(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    const search = defaultData.search;
    let editExceptionCheckForms = search.editExceptionCheckForms;
    search.account = "all";

    editExceptionCheckForms = editExceptionCheckForms.reduce((acc, item, index) => {
        acc.push(
            TASPositivePayExceptionCheckForm.init({ ...item.record, action: index === 0 ? "return" : "approve", returnReason: index === 0 ? "duplicate presentmen" : "" })
        );
        return acc;
    }, []);

    search.editExceptionCheckForms = editExceptionCheckForms;

    let filterUI = editExceptionCheckForms.reduce((acc, item, index) => {
        acc.push(
            TASPositivePayExceptionCheckFormUI.init({ exceptionCheckForm: item })
        );
        return acc;
    }, []);

    const data = BCMSStateManagerCRUD.init(defaultData)
    .update([ "exceptionCheckForms" ], editExceptionCheckForms)
    .submit();
    
    const ui = BCMSStateManagerCRUD.init(getDefaultUI(defaultData.search))
    .update([ "exceptionCheckForms" ], filterUI)
    .submit();

    return <TASPositivePayExceptionsPage data={ data } ui={ ui } />;
}